import electricalImg from "../../assets/pictures/electrical_services.jpg";
import plumbingImg from "../../assets/pictures/Plumbing_services.jpg";
import acImg from "../../assets/pictures/HVAC.jpg";
import paintingImg from "../../assets/pictures/Paint_work.jpg";
import waterTankImg from "../../assets/pictures/water_Tank.jpg";
import carpentryImg from "../../assets/pictures/wooden_work.jpg";
import masonryImg from "../../assets/pictures/tilling_work.jpg";
import maintenanceImg from "../../assets/pictures/general_Maintenance.jpg";

import electricalIcon from "../../assets/icons/services_icons/1.svg";
import plumbingIcon from "../../assets/icons/services_icons/2.svg";
import acIcon from "../../assets/icons/services_icons/3.svg";
import paintingIcon from "../../assets/icons/services_icons/4.svg";
import waterTankIcon from "../../assets/icons/services_icons/5.svg";
import carpentryIcon from "../../assets/icons/services_icons/6.svg";
import masonryIcon from "../../assets/icons/services_icons/7.svg";
import maintenanceIcon from "../../assets/icons/services_icons/8.svg";

export const servicesData = [
  {
    id: 1,
    title: "Electrical Services",
    icon: electricalIcon,
    img: electricalImg,
    desc: "Professional electrical repair, wiring, lighting, and maintenance services across Dubai.",
    fullDescription:
      "Professional electrical services in Dubai for homes, villas, and offices ⚡ We provide safe wiring, lighting installation, socket repair, DB box fixing, power solutions, electrical maintenance, and emergency electrician services. Fast response, affordable prices, and expert electricians for reliable electrical repair and installation across Dubai.",
    features: [
      "Electrical wiring installation",
      "DB box & circuit breaker repair",
      "Lighting & chandelier installation",
      "Socket & switch repair/replacement",
      "Emergency electrician services in Dubai",
      "Residential & commercial electrical maintenance",
    ],
    price: "AED 150 - 500",
  },

  {
    id: 2,
    title: "Plumbing Works",
    icon: plumbingIcon,
    img: plumbingImg,
    desc: "Reliable plumbing services including leak fixing, pipe repair, and drain cleaning",
    fullDescription:
      "Professional plumbing services in Dubai 🚰 including pipe installation, leak repair, drain cleaning, water tank solutions, bathroom & kitchen plumbing, faucet repair, and emergency plumbing services. Our expert plumbers use high-quality materials and modern techniques to deliver reliable, affordable, and long-lasting plumbing solutions for homes, villas, apartments, and offices across Dubai.",
    features: [
      "Leak detection & pipe repair",
      "Bathroom & kitchen plumbing installation",
      "Drain & sewer blockage clearing",
      "Water heater installation & repair",
      "Emergency plumbing services in Dubai",
      "Residential & commercial plumbing solutions",
    ],
    price: "AED 200 - 600",
  },

  {
    id: 3,
    title: "AC Installation & Maintenance",
    icon: acIcon,
    img: acImg,
    desc: "Expert AC installation, repair, duct cleaning, and maintenance services in Dubai.",
    fullDescription:
      "Professional AC repair and AC installation services in Dubai ❄️ We provide AC maintenance, duct cleaning, AC gas refill, split AC repair, central AC services, thermostat fixing, and complete air conditioning solutions for homes, villas, apartments, and offices. Our expert AC technicians work with all major brands to deliver fast, energy-efficient, and affordable cooling services across Dubai.",
    features: [
      "Split & central AC installation",
      "AC gas refilling & leakage repair",
      "AC duct cleaning & deep servicing",
      "Thermostat & cooling issue fixing",
      "Emergency AC repair services",
      "Energy-efficient cooling solutions",
    ],
    price: "AED 250 - 800",
  },

  {
    id: 4,
    title: "Painting & Finishing",
    icon: paintingIcon,
    img: paintingImg,
    desc: "Interior and exterior painting services with premium finishing for homes and offices.",
    fullDescription:
      "Professional painting services in Dubai 🎨 for villas, apartments, offices, and commercial spaces. We provide interior painting, exterior painting, wall painting, decorative paint designs, texture painting, villa repainting, and waterproof coating services using premium quality paints and modern finishing techniques for smooth, long-lasting, and elegant results.",
    features: [
      "Interior & exterior wall painting",
      "Villa & apartment repainting services",
      "Waterproof paint coating solutions",
      "Decorative & texture painting",
      "Surface preparation & crack filling",
      "Professional finishing with premium paint",
    ],
    price: "AED 100 - 400",
  },

  {
    id: 5,
    title: "Water Tank Cleaning",
    icon: waterTankIcon,
    img: waterTankImg,
    desc: "Professional water tank cleaning and sanitization services for safe water storage.",
    fullDescription:
      "Professional water tank cleaning services in Dubai 💧 including water tank disinfection, tank sanitization, bacteria removal, underground and overhead tank cleaning, and hygienic water storage solutions. Our expert team uses specialized equipment and safe cleaning methods to ensure clean, healthy, and safe water for homes, villas, apartments, and commercial properties across Dubai.",
    features: [
      "Overhead & underground tank cleaning",
      "Water tank disinfection & sterilization",
      "Algae, bacteria & sediment removal",
      "Safe food-grade cleaning chemicals",
      "Residential & commercial tank cleaning",
      "Preventive water hygiene maintenance",
    ],
    price: "AED 300 - 700",
  },

  {
    id: 6,
    title: "Carpentry & Woodwork",
    icon: carpentryIcon,
    img: carpentryImg,
    desc: "Custom carpentry and woodwork services including furniture, cabinets, and fittings.",
    fullDescription:
      "Comprehensive maintenance services covering all aspects of your property. From routine checks to repairs, we keep your building in top condition year-round.",
    features: [
      "Custom furniture design & installation",
      "Wooden door & window frame repair",
      "Cabinet, wardrobe & shelving work",
      "Kitchen carpentry & wood fittings",
      "Wood polishing & finishing services",
      "Residential & commercial woodwork solutions",
    ],
    price: "AED 200 - 900",
  },

  {
    id: 7,
    title: "Masonry & Tiling Works",
    icon: masonryIcon,
    img: masonryImg,
    desc: "Expert masonry and tiling services for floors, walls, marble, and stonework.",
    fullDescription:
      "Professional masonry and tiling services in Dubai 🧱 including floor tiling, wall tiles installation, bathroom tiles, kitchen tiles, marble fixing, ceramic tiles, brickwork, stonework, grout repair, and decorative tile designs. Our expert tile contractors deliver durable, stylish, and high-quality finishing for homes, villas, apartments, and commercial properties across Dubai.",
    features: [
      "Floor & wall tile installation",
      "Bathroom & kitchen tiling work",
      "Marble, granite & stone fixing",
      "Brick masonry & block work",
      "Tile replacement & grout repair",
      "Waterproof tiling solutions",
    ],
    price: "AED 180 - 650",
  },

  {
    id: 8,
    title: "General Maintenance Services",
    icon: maintenanceIcon,
    img: maintenanceImg,
    desc: "Complete property maintenance and handyman services for residential and commercial spaces.",
    fullDescription:
      "Professional property maintenance services including routine inspections, preventive maintenance, and fast repair solutions. We specialize in residential and commercial building upkeep, ensuring your property stays safe, functional, and well-maintained year-round.",
    features: [
      "Complete property inspection services",
      "Preventive building maintenance",
      "Handyman repair services",
      "Electrical, plumbing & carpentry fixes",
      "Residential & commercial property upkeep",
      "Fast response maintenance solutions",
    ],
    price: "AED 150 - 500",
  },
];